import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface ReSendOtpRequest extends Partial<AxiosRequestConfig> {
  params: {
    code: string
    number: string
  }
}

interface ReSendOtpResponseData extends ResponseData {
  message: string
}

export interface SendOtpResponse extends AxiosResponse {
  data: ReSendOtpResponseData
}

export function resendOtpAPI(
  { params }: ReSendOtpRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "get",
    url: `/auth/resend/${params.code}/${params.number}/otp`,
  }) as Promise<SendOtpResponse>
}
